import Duck from 'extensible-duck';
import _get from 'lodash/get';
import {
  LOADING_INIT_DATA,
  LOAD_INIT_DATA_SUCCESS,
  LOAD_DATA_FULL_SUCCESS,
} from '../actions/api-actions';
import { ID_USERTYPE } from '../constants/user-type';

const initialState = {
  type: '',
};

export default new Duck({
  namespace: 'ge-delivery',
  store: 'user',
  initialState,
  selectors: duck => ({
    userType: state => state[duck.store].type,
  }),
  reducer: (state, action) => {
    switch (action.type) {
      case LOADING_INIT_DATA: {
        return { ...state, type: '' };
      }
      case LOAD_INIT_DATA_SUCCESS:
      case LOAD_DATA_FULL_SUCCESS: {
        const { data } = action;
        const type =
          _get(data, 'webTrackingDetails[0].staticTracking.userType', 2) || 2;
        return { ...state, type: ID_USERTYPE[type] };
      }
      default:
        return state;
    }
  },
});
